import httpApiInternalAuth from "@/services/http/api-internal/auth";
import { LayoutTypes } from "@/services/context/layout-helper";
import { AuthStates, useAuthStore } from "@/store/auth";
import { useContextStore } from "@/store/context";

export default defineNuxtPlugin(({ $pinia, $apiDrive }) => {
  const authStore = useAuthStore($pinia);
  const contextStore = useContextStore($pinia);

  const showAuth = (cb, args, showAlert = false) => {
    if (authStore.isLogged) {
      if (cb) {
        cb(args);
      }
    } else if (showAlert) {
      if (cb) {
        authStore.setConnexionCallback({
          caller: cb,
          args
        });
      }
      authStore.setAuthState(AuthStates.connexionRequired);
    } else if (contextStore.layout === LayoutTypes.mobile) {
      authStore.setAuthState(null);
      navigateTo("/connexion", { replace: true })
    } else {
      authStore.setAuthState(AuthStates.connexion);
    }
  };
  const needAuth = (cb, args) => {
    showAuth(cb, args, true)
  };

  handleRefreshToken(authStore, $apiDrive);

  return {
    provide: {
      showAuth,
      needAuth
    }
  }
});

const handleRefreshToken = (authStore, apiDrive) => {
  apiDrive.setResponseInterceptor((response) => {
    return response;
  }, async (error) => {
    if (error.response && error.response.status === 401 && authStore.isLogged) {
      try {
        const { access_token } = await httpApiInternalAuth.refreshToken();
        authStore.setToken(access_token);
        error.config.headers.Authorization = `Bearer ${access_token}`;
        return apiDrive.provider.request(error.config);
      } catch (e) {
        authStore.logout();
        throw createError({
          statusCode: 401
        });
      }
    }
    return Promise.reject(error);
  });
};
